// 真實輪帶資料存取 — 來源 Unity Data/RandomReelStripData.asset，由 scripts/parse-reel-strips.mjs
// 解析匯入至 realReelStrips.data.ts（見該檔頭註記；重新產生時重跑該 script）。
// 7 條真實加權輪帶：index 0-5 對應主輪 0-5，index 6 對應 Tracker 頂輪。
// 真實賠付表（PayTableData.asset 的 SymbolOdds）仍是空的，但輪帶符號分布本身是真實資料，不是 Mock。

import { REAL_REEL_STRIPS } from './realReelStrips.data'

function requireStrip(reelIndex: number): readonly number[] {
  if (reelIndex < 0 || reelIndex >= REAL_REEL_STRIPS.length) {
    throw new Error(`未知輪帶 index: ${reelIndex}`)
  }
  return REAL_REEL_STRIPS[reelIndex]!
}

/**
 * 從指定輪帶隨機挑一個連續視窗（模擬真實轉輪「停在某個位置、往下顯示連續 N 格」的機制）。
 * 視窗超出輪帶尾端時回到開頭（輪帶視為環狀）。
 */
export function pickReelWindow(reelIndex: number, rows: number): number[] {
  const strip = requireStrip(reelIndex)
  const start = Math.floor(Math.random() * strip.length)
  return Array.from({ length: rows }, (_, i) => strip[(start + i) % strip.length]!)
}

/** 從指定輪帶隨機抽一個單一符號（消除補位用；每格獨立抽樣，非連續視窗）。 */
export function pickReelSymbol(reelIndex: number): number {
  const strip = requireStrip(reelIndex)
  return strip[Math.floor(Math.random() * strip.length)]!
}
